import { apiJson } from '../utils/api_utils.js?v=20260730a';
import { getActiveLanguage } from '../i18n/i18n_service.js?v=20260722a';
import { getUserPreference, setUserPreference } from '../user/user_preferences.js?v=20260812a';
import { compareVersions, currentReleaseVersions, unseenVersions } from './whats_new_versions.mjs';

// „Was ist neu“ (Katalog-Release K5, docs/architecture/catalog-release-k1-inventory.md).
// Nach dem Start zeigt Stable nur das aktuelle Release, sofern noch ungesehen.
// Die Bestaetigung bleibt serverseitig und geraeteuebergreifend gespeichert.
// Auch die Versionsanzeige oeffnet ausschliesslich das aktuelle Release.

const SEEN_KEY = 'changelogSeenVersion';
const BADGE_ID = 'appVersionBadge';
let opening = null;

function fetchChangelog() {
  const lang = encodeURIComponent(getActiveLanguage() || '');
  return apiJson(`/api/changelog?lang=${lang}`);
}

async function showModal(options) {
  const { openWhatsNewModal } = await import('./lazy_dialog_runtime.js?v=20260904f');
  return openWhatsNewModal(options);
}

/** After start: only the target environment shows unseen release notes. */
export async function maybeShowWhatsNew() {
  const payload = await fetchChangelog();
  if (payload.role !== 'replica' || !payload.versions?.length) return;
  const latest = payload.versions[0].version;
  const seen = getUserPreference(SEEN_KEY, null);
  const unseen = unseenVersions(payload.versions, seen).filter(entry => entry.entries.length);
  if (unseen.length) await showModal({ versions: unseen, mode: 'new' });
  if (!seen || compareVersions(latest, seen) > 0) await setUserPreference(SEEN_KEY, latest);
}

/** Version badge: only the current published release, even after acknowledgement. */
export function openWhatsNew() {
  if (opening) return opening;
  opening = fetchChangelog()
    .then(payload => showModal({ versions: currentReleaseVersions(payload.versions), mode: 'new' }))
    .catch(error => console.warn('„Was ist neu“ konnte nicht geladen werden:', error))
    .finally(() => { opening = null; });
  return opening;
}

export function bindWhatsNewBadge(root = document) {
  const badge = root.getElementById?.(BADGE_ID);
  if (!badge || badge.dataset.whatsNewBound === 'true') return;
  badge.dataset.whatsNewBound = 'true';
  badge.classList.add('is-clickable');
  badge.setAttribute('role', 'button');
  badge.setAttribute('tabindex', '0');
  badge.setAttribute('aria-label', 'Was ist neu');
  badge.addEventListener('click', () => { openWhatsNew(); });
  badge.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openWhatsNew();
    }
  });
}
